'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSimulated = undefined;

var _isStatus = require('./isStatus');

var _messageStatusTypes = require('../constants/messageStatusTypes');

var isSimulated = exports.isSimulated = (0, _isStatus.isStatus)(_messageStatusTypes.SIMULATED);